// Form Error Message
export const REQUIRED_ERROR_MESSAGE = '필수 입력 항목이에요.';
export const MIN_LENGTH_ERROR_MESSAGE = '자 이상 입력해야 해요.';
export const TRIM_ERROR_MESSAGE = '앞뒤 공백 제외';
export const MAX_LENGTH_ERROR_MESSAGE = '자까지 입력할 수 있어요.';

// Error Alert
// 알 수 없는 오류 시의 안내 메시지
export const DEFAULT_ERROR_TITLE = '일시적인 오류가 발생했어요';
export const DEFAULT_ERROR_MESSAGE =
  '요청을 처리할 수 없었어요. 다시 시도해주세요.';

// Not Found 시의 안내 메시지
export const NOT_FOUND_ERROR_TITLE = '존재하지 않는 페이지에요';
export const NOT_FOUND_ERROR_MESSAGE = '이전 페이지부터 다시 탐색해주세요.';

// Error Toast Message
export const ERROR_TOAST_MESSAGE_ON_SERVER_ERROR =
  '요청을 처리할 수 없었습니다.\r\n잠시 후 다시 시도해주세요.';

//Error Token Expired
export const TOKEN_EXPIRED_MESSAGE = '기한이 만료된 토큰입니다';

// Error Not LoggedIn User

export const NOT_LOGGED_IN_USER_MESSAGE = '로그인이 필요한 서비스입니다.';
export const NOT_SIGN_UP_USER_MESSAGE = '회원가입이 필요한 서비스입니다.';

export const IS_SIGN_UP_USER_MESSAGE = '이미 회원가입이 되어있는 사용자입니다.';
